import { assign } from 'xstate';
import { Context } from '../bookingsMachine';

const assignBookings = assign<Context, any>((ctx, evt) => ({
    ...evt.data,
    Results: [...ctx.Results, ...evt.data.Results],
}));

export default assignBookings;
